import path from 'node:path';
import fs from 'node:fs';
import { MicrofrontendsServer } from '../config/microfrontends/server';
import { MicrofrontendError } from '../config/errors';

export interface MicrofrontendsPort {
  name: string;
  version: string;
  port: number;
}

interface PortResult {
  port: number;
}

export function mfePort(packageDir: string): MicrofrontendsPort {
  const { name: appName, version } = getPackageJson(packageDir);
  const result = loadConfig({ packageDir, appName });
  if (!result) {
    throw new MicrofrontendError(
      `Unable to determine configured port for ${appName}`,
      { type: 'config', subtype: 'not_found' },
    );
  }
  const { port } = result;
  return {
    name: appName,
    version,
    port,
  };
}

function getPackageJson(packageDir: string): { name: string; version: string } {
  const filePath = path.join(packageDir, 'package.json');
  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as {
    name: string;
    version: string;
  };
}

function loadConfig({
  packageDir,
  appName,
}: {
  packageDir: string;
  appName: string;
}): PortResult | undefined {
  let config: MicrofrontendsServer | undefined;
  try {
    config = MicrofrontendsServer.infer({
      directory: packageDir,
    });
  } catch (e) {
    return undefined;
  }
  const app = config.config.getApplication(appName);
  const port =
    app.development.local.port ??
    (app.development.local.protocol === 'https' ? 443 : 80);
  return { port };
}
